// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2j7fs","label":"LabeledBox_label__1UPOg"};